<footer class="footer">
  <div class="container-fluid">
    <div class="row">
        <div class="col-md-6 text-center text-md-start">
            © 2025 <span class="fw-semibold">{{ credits.name }}</span>
        </div>
      <div class="col-md-6">
        <div class="text-md-end d-none d-md-block">
          
        </div>
      </div>
    </div>
  </div>
</footer>
